import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { AddShiftTemplateData, AdministrationResultStatus, PaginationArgs, ShiftTemplateData, ShiftTemplateDataAdministrationResult, ShiftTemplateDataListAdministrationResult, UpdateShiftTemplateData, UserProfileDataPaginationDataAdministrationResult } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class ShiftTemplateService {
  
  constructor(private systemApiClient: SystemApiClient) { }

  retrieveAllShiftTemplates(): Observable<ShiftTemplateDataListAdministrationResult>  {
    return this.systemApiClient.retrieveAllShiftTemplates();
  }
  
  retrieveShiftTemplateById(shiftTemplateId: number | undefined): Observable<ShiftTemplateDataAdministrationResult> {
    return this.systemApiClient.retrieveShiftTemplateById(shiftTemplateId);
  }

  updateShiftTemplate(body: UpdateShiftTemplateData | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.updateShiftTemplate(body);
  }

  addShiftTemplate(body: AddShiftTemplateData  | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.addShiftTemplate(body);
  }

  deleteShiftTemplate(shiftTemplateId: number | undefined): Observable<AdministrationResultStatus> {
    return this.systemApiClient.deleteShiftTemplate(shiftTemplateId);
  }

  retrieveAllEmployeesWithServices(body: PaginationArgs | undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
    return this.systemApiClient.retrieveAllEmployeesWithServices(body);
  }
}